import { FaCheck } from 'react-icons/fa'
import { FaQuestion } from 'react-icons/fa'
import { MdSmsFailed } from 'react-icons/md'
import ResultBox from './components/ResultBox'
import { MdMessage } from 'react-icons/md'

export const renderTestResultCategory = (category) => {
  switch (category) {
    case 'NSS':
    case 'nss':
      return (
        <div className="test-success lab-test-category">
          <FaCheck />
          <div>
            <span>{category}</span>
            <p style={{ fontSize: '0.85rem', marginTop: '8px', marginBottom: 0, paddingTop: '4px' }}>No Sperm Seen</p>
          </div>
        </div>
      )

    case 'positive':
    case 'Positive':
      return (
        <div className="test-warning lab-test-category">
          <MdSmsFailed />
          <div>
            <span>{category}</span>
            <p style={{ fontSize: '0.85rem', marginTop: '8px', marginBottom: 0, paddingTop: '4px' }}>Sperm seen in sample</p>
          </div>
        </div>
      )

    case 'error':
    case 'Error':
      return (
        <div className="test-failure lab-test-category">
          <FaQuestion />
          <div>
            <span>{category}</span>
            <p style={{ fontSize: '0.85rem', marginTop: '8px', marginBottom: 0, paddingTop: '4px' }}>There was an error examining your sample</p>
          </div>
        </div>
      )

    default:
      return (
        <div className="lab-test-category">
          <FaQuestion /> <span>{category}</span>
        </div>
      )
  }
}

export const renderTestResultMessage = (result, message) => {

  let highlightClass = ''
  switch (result) {
    case 'NSS':
    case 'nss':
      highlightClass = 'highlight-nss'
      break
    case 'positive':
    case 'Positive':
      highlightClass = 'highlight-positive'
      break
    case 'error':
    case 'Error':
      highlightClass = 'highlight-error'
      break
    default:
      highlightClass = ''
      break
  }

  return (
    <ResultBox
     icon={<MdMessage />}
     label="Test Result Message"
     value={message ?? 'N/A'}
     highlightClass={highlightClass}
    />
  )
}

 
